export const IncidentsMock = [
  {
    date: "4/7",
    id: "1",
    priority: 1,
    subject: "C0000-automatic-alert_ad_01..."
  },
  {
    date: "4/7",
    id: "2",
    priority: 2,
      subject: "C0000-automatic-alert_ad_01..."
  },
  {
    date: "4/7",
    id: "2",
    priority: 2,
      subject: "C0000-automatic-alert_ad_01..."
  },
  {
    date: "4/7",
    id: "2",
    priority: 2,
      subject: "C0000-automatic-alert_ad_01..."
  },
  {
    date: "4/7",
    id: "2",
    priority: 2,
      subject: "C0000-automatic-alert_ad_01..."
  }
];

export const incidentsSummaryMock = {
  Priority1Count: 1,
  Priority2Count: 4,
  Priority3Count: 5,
  Priority4Count: 12
};



// WEBPACK FOOTER //
// ./src/dashboard/widgets/incidentsMockData.js